<template>
  <div>
    <v-card>
      <v-card-title>
        Termo LGPD
      </v-card-title>

      <v-divider class="mt-0"></v-divider>

      <!-- filter quicksearch -->
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <!-- search -->
        <v-row>
          <v-col
            cols="12"
            md="8"
            lg="4"
          >
            <v-autocomplete
              v-model="typeFilterSelected"
              :items="select_options"
              item-text="text"
              item-value="value"
              label="Tipo do filtro"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="8"
            lg="6"
          >
            <v-text-field
              v-model="filterOptions.input_value"
              :append-icon="icons.mdiMagnify"
              label="Buscar Cliente"
              clearable
              outlined
              hide-details
              dense
              class="user-search mb-4"
              @click:append="filterQuickSearch"
              @click:clear="filterReset"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            color="primary"
            class="mb-5 pl-4"
            outlined
            @click="addTermLgpd"
          >
            <v-icon>{{ icons.mdiPlaylistPlus }}</v-icon>
            <span class="pl-2">Novo</span>
          </v-btn>
        </div>
      </v-card-text>

      <!--table-->
      <v-data-table
        :headers="headers"
        :items="termLgpdList"
        :loading="isLoadingTableData"
        loading-text="Carregando dados..."
        :page.sync="pageOptions.page"
        :items-per-page="pageOptions.itemsPerPage"
        fixed-header
        :height="heightDynamic"
        hide-default-footer
        disable-sort
        @page-count="pageCount = $event"
      >
        <!-- action (edit, delete, etc) -->
        <template v-slot:item.actions="{ item }">
          <v-tooltip
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="me-2"
                v-bind="attrs"
                v-on="on"
                @click="editTermLgpd(item)"
              >
                <v-icon v-if="item.id === modalOptions.loading ? false : true">
                  {{ icons.mdiEyeOutline }}
                </v-icon>
                <v-progress-circular
                  v-if="item.id === modalOptions.loading ? true : false"
                  indeterminate
                  :size="25"
                  color="gray"
                ></v-progress-circular>
              </v-btn>
            </template>
            <span>Visualizar</span>
          </v-tooltip>

          <v-tooltip
            top
            color="purple"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="me-2"
                color="purple"
                v-bind="attrs"
                v-on="on"
                @click="resendLinkWhatsapp(item)"
              >
                <v-icon v-if="item.id === modalOptions.loading2 ? false : true">
                  {{ icons.mdiAutorenew }}
                </v-icon>
                <v-progress-circular
                  v-if="item.id === modalOptions.loading2 ? true : false"
                  indeterminate
                  :size="25"
                  color="gray"
                ></v-progress-circular>
              </v-btn>
            </template>
            <span>Reenviar link</span>
          </v-tooltip>

          <v-tooltip
            top
            color="info"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="me-2"
                color="info"
                v-bind="attrs"
                v-on="on"
                @click="handleOpenUpdateModal(item)"
              >
                <v-icon v-if="item.id === modalOptions.loading3 ? false : true">
                  {{ icons.mdiPencil }}
                </v-icon>
                <v-progress-circular
                  v-if="item.id === modalOptions.loading3 ? true : false"
                  indeterminate
                  :size="25"
                  color="gray"
                ></v-progress-circular>
              </v-btn>
            </template>
            <span>Editar dados</span>
          </v-tooltip>
        </template>
        <!--data empty-->
        <template v-slot:no-data>
          {{ noDataText }}
        </template>

        <!--field phone_cell-->
        <template v-slot:item.client_phone="{item}">
          <v-tooltip
            top
            color="success"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="success"
                v-bind="attrs"
                v-on="on"
                @click="chatWhatsapp(item.client_phone)"
              >
                <v-icon>
                  {{ icons.mdiWhatsapp }}
                </v-icon>
              </v-btn>
            </template>
            <span>Entrar em contato</span>
          </v-tooltip>
          {{ item.client_phone }}
          <!-- <v-icon
            medium
            @click="chatWhatsapp(item.client_phone)"
          >
            {{ icons.mdiWhatsapp }}
          </v-icon>
          {{ item.client_phone }} -->
        </template>
      </v-data-table>

      <v-divider class="mt-4"></v-divider>

      <!-- pagination -->
      <v-card-text class="pt-2 pb-1">
        <v-row>
          <v-col
            lg="12"
            cols="12"
            class="d-flex justify-center"
          >
            <v-pagination
              v-model="pageOptions.page"
              total-visible="6"
              :length="pageOptions.pageCount"
              @input="updatePage"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="modalOptions.modal"
      width="900"
    >
      <lgpd-modal-vendor
        :close-modal="closeModal"
        :is-edit="modalOptions.editItem"
        :is-valid="modalOptions.validItem"
        :is-disable="modalOptions.disableItem"
        :is-remake="modalOptions.remakeItem"
        :send-contract="modalOptions.sendContract"
        :term-lgpd-item="modalOptions.termLgpdItem"
        :user-data="userData"
        :updated-table="updatedTable"
      />
    </v-dialog>
    <v-dialog
      v-model="openUpdateModal"
      width="900"
    >
      <LgpdUpdateModal
        :close-modal="closeUpdateModal"
        :term-lgpd-item="modalOptions.termLgpdItem"
        :user-data="userData"
        @getTableData="handleUpdateTable"
      />
    </v-dialog>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import axiosIns from '@/plugins/axios'
import {
  mdiAccountOutline,
  mdiAutorenew,
  mdiCalendar,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiExportVariant,
  mdiEyeOutline,
  mdiFileDocumentOutline,
  mdiFilter,
  mdiFilterMenu,
  mdiFilterRemove,
  mdiLoading,
  mdiMagnify,
  mdiPencil,
  mdiPencilOutline,
  mdiPlaylistPlus,
  mdiPlus,
  mdiSquareEditOutline,
  mdiTextBoxSearch,
  mdiWhatsapp,
} from '@mdi/js'
import LgpdModalVendor from './LgpdModalVendor.vue'
import LgpdUpdateModal from './LgpdUpdateModal.vue'

export default {
  components: {
    LgpdModalVendor,
    LgpdUpdateModal,
  },

  data: () => ({
    icons: {
      mdiSquareEditOutline,
      mdiDotsVertical,
      mdiPlaylistPlus,
      mdiPencilOutline,
      mdiFileDocumentOutline,
      mdiDeleteOutline,
      mdiPlus,
      mdiExportVariant,
      mdiAccountOutline,
      mdiFilter,
      mdiFilterRemove,
      mdiWhatsapp,
      mdiCalendar,
      mdiFilterMenu,
      mdiLoading,
      mdiEyeOutline,
      mdiMagnify,
      mdiPencil,
      mdiTextBoxSearch,
      mdiAutorenew,
    },
    userData: {
      name: '',
      phone: '',
    },

    /* filter */
    select_options: [
      {
        text: 'NOME DO CLIENTE',
        value: 'client',
      },
      {
        text: 'NÚMERO DA PROPOSTA',
        value: 'proposal',
      },
      {
        text: 'CPF DO CLIENTE',
        value: 'document',
      },
    ],
    typeFilterSelected: '',
    filterOptions: {
      input_value: '',
      validate: true,
      proposal_number: '',
      cpf_cnpj: '',
      client_name: '',
      vendor_name: '',
    },

    /* data table */
    termLgpdList: [],
    noDataText: 'Nenhum registro encontrado',
    heightDynamic: '400px',
    isLoadingTableData: true,
    headers: [
      { text: 'DATA', value: 'contract_date' },
      { text: 'PROPOSTA', value: 'proposal_number' },
      { text: 'CLIENTE', value: 'client_name' },
      { text: 'VENDEDOR', value: 'vendor_name' },
      { text: 'CPF/CNPJ', value: 'cpf_cnpj' },
      { text: 'CELULAR WHATS', value: 'client_phone' },
      { text: 'MODELO', value: 'vehicle_model.vehicle_model' },
      { text: 'SEGURO', value: 'life_insurance' },
      { text: 'LANCE', value: 'bid_fixed' },
      { text: 'OPÇÕES', value: 'actions', align: 'center' },
    ],

    /* router */
    routeOptions: {
      resource: 'list',
      method: 'post',
      params: {},
    },

    /* pagination */
    pageOptions: {
      page: 1,
      pageCount: 0,
      itemsPerPage: 15,
    },

    openUpdateModal: false,

    /* modal */
    modalOptions: {
      termLgpdItem: {},
      loading: '',
      loading2: '',
      loading3: '',
      modal: false,
      idItem: '',
      editItem: false,
      disableItem: false,
      validItem: false,
      remakeItem: false,
      sendContract: false,
    },
  }),

  watch: {
    typeFilterSelected(n) {
      if (n === 'client') {
        this.filterOptions.client_name = true
        this.filterOptions.proposal_number = false
        this.filterOptions.cpf_cnpj = false
        this.filterOptions.vendor_name = false
      } else if (n === 'proposal') {
        this.filterOptions.client_name = false
        this.filterOptions.proposal_number = true
        this.filterOptions.cpf_cnpj = false
        this.filterOptions.vendor_name = false
      } else if (n === 'vendor_name') {
        this.filterOptions.client_name = false
        this.filterOptions.proposal_number = false
        this.filterOptions.cpf_cnpj = false
        this.filterOptions.vendor_name = true
      } else {
        this.filterOptions.client_name = false
        this.filterOptions.proposal_number = false
        this.filterOptions.cpf_cnpj = true
        this.filterOptions.vendor_name = false
      }
    },
  },

  created() {
    this.initialize()
    this.getDataUser()
  },

  methods: {
    handleUpdateTable() {
      this.openUpdateModal = false
      this.getTermLgpd()
    },
    initialize() {
      this.getTermLgpd()
    },

    async handleOpenUpdateModal(item) {
      this.modalOptions.loading3 = item.id
      this.modalOptions.idItem = item.id
      this.modalOptions.editItem = true
      await axiosIns
        .get(`/api/v1/integration/lgpd_term/edit/${item.id}`)
        .then(res => {
          const value = res.data.data
          this.modalOptions.termLgpdItem = {
            id: value.id,
            proposal_number: value.proposal_number,
            receipt_number: value.receipt_number,
            client_name: value.client_name,
            cpf_cnpj: value.cpf_cnpj,
            client_phone: value.client_phone,
            contract_date: value.contract_date,
            bid_fixed: value.bid_fixed,
            life_insurance: value.life_insurance,
            customer_subscription: value.customer_subscription,
            submit: value.submit,
            email: value.email,
            vendor_name: this.userData.name,
            conferred_by: value.conferred_by,
            vehicle_model: value.vehicle_model,
            observation: value.observation,
            term_refused: value.term_refused,
            code_validity_date: value.code_validity_date,
            auth_code: value.auth_code,
            term_revalidated: value.term_revalidated,
            validated_date: value.validated_date,
            vendor_cpf: value.vendor_cpf,
            phone_vendor: this.userData.phone,
            valid_code: value.valid_code,
            wa_sent: value.wa_sent,
            term_status: value.term_status,
          }
          this.modalOptions.loading3 = ''
          this.openUpdateModal = true
        })
        .catch(async err => {
          this.modalOptions.loading3 = ''
          await this.$swal({
            icon: 'error',
            title: 'Erro ao visualizar termo',
            showConfirmButton: false,
            text: err,
            timer: 3000,
          })
        })
    },
    closeUpdateModal() {
      this.openUpdateModal = false
    },

    /* data table methods */
    async getTermLgpd() {
      this.isLoadingTableData = true
      this.termLgpdList = []

      await axiosIns
        .get('/api/v1/integration/lgpd_term/index', this.routeOptions.params)
        .then(res => {
          this.heightDynamic = `${window.screen.height * 0.45}px`
          res.data.data.map(value => {
            this.termLgpdList.push({
              id: value.id,
              proposal_number: value.proposal_number,
              receipt_number: value.receipt_number,
              client_name: value.client_name,

              cpf_cnpj: value.cpf_cnpj,
              client_phone: value.client_phone,
              contract_date: value.contract_date,
              bid_fixed: value.bid_fixed ? 'Sim' : 'Não',
              life_insurance: value.life_insurance ? 'Sim' : 'Não',
              customer_subscription: value.customer_subscription,
              submit: value.submit,

              // email: value.email,
              vendor_name: value.vendor_name,
              conferred_by: value.conferred_by,
              vehicle_model: value.vehicle_model,
              observation: value.observation,
              term_refused: value.term_refused,
              code_validity_date: value.code_validity_date,
              auth_code: value.auth_code,
              term_revalidated: value.term_revalidated,
              validated_date: value.validated_date,
              vendor_cpf: value.vendor_cpf,
              phone_vendor: value.phone_vendor,
              valid_code: value.valid_code,
              wa_sent: value.wa_sent,
              term_status: value.term_status,
            })
          })
          this.pageOptions.page = res.data.meta.current_page
          this.pageOptions.itemsPerPage = res.data.meta.per_page
          this.pageOptions.pageCount = res.data.meta.last_page
        })
        .catch(err => {
          this.noDataText = `Contate o suporte do sistema: ${err}`
        })
        .finally(() => {
          this.isLoadingTableData = false
        })
    },

    async confirmAction() {
      const result = await this.$swal({
        title: 'Atenção!',
        text: 'Você tem certeza que deseja reenviar o link?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#dc3545',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      })

      return result.isConfirmed
    },

    async resendLinkWhatsapp(item) {
      const confirmAction = await this.confirmAction()
      if (!confirmAction) return

      this.modalOptions.loading2 = item.id
      await axiosIns
        .post('/api/v1/integration/lgpd_term/resend_link', {
          id: item.id,
        })
        .then(() => {
          this.$swal({
            icon: 'success',
            title: 'Reenvio de link',
            showConfirmButton: false,
            text: 'Link reenviado com sucesso!',
            timer: 3000,
          })
        })
        .catch(err => {
          this.$swal({
            icon: 'error',
            title: 'Reenvio de link',
            showConfirmButton: false,
            text: err,
            timer: 3000,
          })
        })
      this.modalOptions.loading2 = ''
    },

    /* pagination methods */
    async updatePage() {
      this.isLoadingTableData = true
      this.termLgpdList = []

      await axiosIns
        .get(`/api/v1/integration/lgpd_term/index?page=${this.pageOptions.page}`)
        .then(res => {
          res.data.data.map(value => {
            this.termLgpdList.push({
              id: value.id,
              proposal_number: value.proposal_number,
              receipt_number: value.receipt_number,
              client_name: value.client_name,
              cpf_cnpj: value.cpf_cnpj,
              client_phone: value.client_phone,
              contract_date: value.contract_date,
              bid_fixed: value.bid_fixed,
              life_insurance: value.life_insurance,
              customer_subscription: value.customer_subscription,
              submit: value.submit,
              email: value.email,
              vendor_name: value.vendor_name,
              conferred_by: value.conferred_by,
              vehicle_model: value.vehicle_model,
              observation: value.observation,
              term_refused: value.term_refused,
              code_validity_date: value.code_validity_date,
              auth_code: value.auth_code,
              term_revalidated: value.term_revalidated,
              validated_date: value.validated_date,
              vendor_cpf: value.vendor_cpf,
              phone_vendor: value.phone_vendor,
              valid_code: value.valid_code,
              wa_sent: value.wa_sent,
              term_status: value.term_status,
            })
          })
          this.pageOptions.itemsPerPage = res.data.meta.per_page
          this.pageOptions.pageCount = res.data.meta.last_page
        })
        .catch(err => {
          this.noDataText = `Contate o suporte do sistema: ${err}`
        })
        .finally(() => {
          this.isLoadingTableData = false
        })
    },

    /* filter methods */
    async filterQuickSearch() {
      this.isLoadingTableData = true
      this.routeOptions = {
        resource: 'filter',
        method: 'post',
        params: this.filterOptions,
      }
      this.termLgpdList = []
      await axiosIns
        .post('/api/v1/integration/lgpd_term/filter', this.routeOptions.params)
        .then(res => {
          res.data.data.map(value => {
            this.termLgpdList.push({
              id: value.id,
              proposal_number: value.proposal_number,
              receipt_number: value.receipt_number,
              client_name: value.client_name,
              cpf_cnpj: value.cpf_cnpj,
              client_phone: value.client_phone,
              contract_date: value.contract_date,
              bid_fixed: value.bid_fixed,
              life_insurance: value.life_insurance,
              customer_subscription: value.customer_subscription,
              submit: value.submit,
              email: value.email,
              vendor_name: value.vendor_name,
              conferred_by: value.conferred_by,
              vehicle_model: value.vehicle_model,
              observation: value.observation,
              term_refused: value.term_refused,
              code_validity_date: value.code_validity_date,
              auth_code: value.auth_code,
              term_revalidated: value.term_revalidated,
              validated_date: value.validated_date,
              vendor_cpf: value.vendor_cpf,
              phone_vendor: value.phone_vendor,
              valid_code: value.valid_code,
              wa_sent: value.wa_sent,
              term_status: value.term_status,
            })
          })
          this.pageOptions.page = res.data.meta.current_page
          this.pageOptions.itemsPerPage = res.data.meta.per_page
          this.pageOptions.pageCount = res.data.meta.last_page
        })
        .catch(err => {
          this.noDataText = `Contate o suporte do sistema: ${err}`
        })
        .finally(() => {
          this.isLoadingTableData = false
        })
    },

    async filterReset() {
      this.isLoadingTableData = true
      this.termLgpdList = []
      this.routeOptions = {
        resource: 'list',
        method: 'post',
        params: {},
      }

      this.initialize()
    },

    /* modal methods */
    async editTermLgpd(item) {
      this.modalOptions.loading = item.id
      this.modalOptions.idItem = item.id
      this.modalOptions.editItem = true
      await axiosIns
        .get(`/api/v1/integration/lgpd_term/edit/${item.id}`)
        .then(res => {
          const value = res.data.data
          this.modalOptions.termLgpdItem = {
            id: value.id,
            proposal_number: value.proposal_number,
            receipt_number: value.receipt_number,
            client_name: value.client_name,
            cpf_cnpj: value.cpf_cnpj,
            client_phone: value.client_phone,
            contract_date: value.contract_date,
            bid_fixed: value.bid_fixed,
            life_insurance: value.life_insurance,
            customer_subscription: value.customer_subscription,
            submit: value.submit,
            email: value.email,
            vendor_name: this.userData.name,
            conferred_by: value.conferred_by,
            vehicle_model: value.vehicle_model,
            observation: value.observation,
            term_refused: value.term_refused,
            code_validity_date: value.code_validity_date,
            auth_code: value.auth_code,
            term_revalidated: value.term_revalidated,
            validated_date: value.validated_date,
            vendor_cpf: value.vendor_cpf,
            phone_vendor: this.userData.phone,
            valid_code: value.valid_code,
            wa_sent: value.wa_sent,
            term_status: value.term_status,
          }
          this.modalOptions.loading = ''
          this.modalOptions.modal = true
        })
        .catch(async err => {
          this.modalOptions.loading = ''
          await this.$swal({
            icon: 'error',
            title: 'Erro ao visualizar termo',
            showConfirmButton: false,
            text: err,
            timer: 3000,
          })
        })
    },

    async addTermLgpd() {
      this.clearModal()
      this.modalOptions.editItem = false
      this.modalOptions.validItem = false
      this.modalOptions.disableItem = false
      this.modalOptions.modal = true
    },

    async closeModal() {
      this.clearModal()
      this.modalOptions.modal = false
    },

    async clearModal() {
      Object.keys(this.modalOptions.termLgpdItem).forEach(key => {
        this.modalOptions.termLgpdItem[key] = ''
      })
    },

    async getDataUser() {
      await axiosIns.get('api/v1/records/user/logged_in_user')
        .then(res => {
          this.userData = {
            name: res.data.data.name,
            phone: res.data.data.cellphone,
          }
        })
    },

    async updatedTable() {
      await this.getTermLgpd()
    },
    chatWhatsapp(phone) {
      window.open(`https://wa.me/55${phone}`, '_blank')
    },
  },
}
</script>
